import { Flex } from 'foundations-components/components/Flex';
import { useIsMobile } from 'pricing-pages-ui-components/hooks/useMedia';
import { NavMarker } from 'react-rhumb';
import { ErrorPageContent } from '../components/common/error/ErrorPageContent';
import HeaderLayout from '../components/layout/HeaderLayout';
import MobileWrapper from '../components/mobile/containers/MobileWrapper';
import { PRODUCT_INFO_MISSING } from '../constants/ErrorCauses';
import { useAnchorLinkScroll } from '../hooks/htmlElementHooks';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MissingInfoFallbackPage = ({
  navItem
}) => {
  useAnchorLinkScroll();
  useDocumentTitle(navItem);
  const isMobile = useIsMobile();
  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileWrapper, {
      navItem: navItem,
      navMarkerName: "FALLBACK_ERROR_CONTENT",
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "center",
        padding: "1000",
        children: /*#__PURE__*/_jsx(ErrorPageContent, {
          errorCause: PRODUCT_INFO_MISSING
        })
      })
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    "data-selenium-id": "page-success",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "FALLBACK_ERROR_CONTENT"
    }), /*#__PURE__*/_jsx(HeaderLayout, {
      selectedNavItem: navItem,
      children: /*#__PURE__*/_jsx(Flex, {
        flexDirection: "column",
        alignItems: "center",
        padding: "1000",
        children: /*#__PURE__*/_jsx(ErrorPageContent, {
          errorCause: PRODUCT_INFO_MISSING
        })
      })
    })]
  });
};
export default MissingInfoFallbackPage;